


























































































import Debug from "@/components/utility/Debug.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { InvoiceStatusEnum } from "@/lib/enum/invoice-status.enum";
import { IGroupTypeEntityCreateDialog } from "@/lib/utility/group/interface/group-type-entity-create-dialog.interface";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IContract } from "@/models/contract.entity";
import { InvoiceLine } from "@/models/invoice-line.entity";
import { DocumentDirectionEnum, IInvoice, Invoice } from "@/models/invoice.entity";
import { IReference } from "@/models/reference.entity";
import { currencySymbolMap } from "@/store/mapper/currency-symbol.map";
import { CompanyModule } from "@/store/modules/company.store";
import { IRefSuggestion } from "@/store/modules/fleet-aggregation.store";
import { FleetModule } from "@/store/modules/fleet.store";
import { GroupModule } from "@/store/modules/group.store";
import { PartnerModule } from "@/store/modules/partner";
import { ReportPaginationModule } from "@/store/modules/report-pagination.store";
import { VehicleModule } from "@/store/modules/vehicle.store";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref } from "vue-property-decorator";
import CostCardDocuments from "../cost/CostCardDocuments.vue";
import GroupTypeSelectionDetailComponent from "../group/GroupTypeSelectionDetailComponent.vue";
import ConfirmActionDialog from "../utility/ConfirmActionDialog.vue";
import FileInputMixin from "../utility/FileInputMixin.vue";
import MDetailViewGrid from "../utility/mmmint/MDetailViewGrid.vue";
import RefsSelect from "../utility/RefsSelect.vue";
import SelectEntity from "../utility/SelectEntity.vue";
import InvoiceCreateDialogPartyForm from "./InvoiceCreateDialogPartyForm.vue";
import InvoiceFormPreview from "./InvoiceFormPreview.vue";
import VueI18n from "vue-i18n";
import { simpleDate } from "@/lib/utility/date-helper";

type TableRowType = {
  key: VueI18n.TranslateResult | string;
  value: any | undefined;
  note: string | undefined | null;
  isOptional?: boolean;
};

@Component({
  components: {
    ConfirmActionDialog,
    CostCardDocuments,
    RefsSelect,
    SelectEntity,
    Debug,
    InvoiceCreateDialogPartyForm,
    InvoiceFormPreview,
    MDetailViewGrid,
    GroupTypeSelectionDetailComponent
  },
  filters: {}
})
export default class CreateInvoiceOutboundDialog extends mixins(FileInputMixin, RulesMixin, PermissionMixin)
  implements IGroupTypeEntityCreateDialog {
  readonly currencySymbolMap = currencySymbolMap;
  readonly CurrencyEnum = CurrencyEnum;
  readonly InvoiceStatusEnum = InvoiceStatusEnum;
  readonly Invoice = Invoice;

  @Ref("invoiceForm") invoiceForm!: InvoiceFormPreview;

  @Ref("costCardDocuments")
  costCardDocuments!: CostCardDocuments;

  @Prop()
  partnerId!: string;

  @Prop({ default: "create" })
  text!: string;

  @Prop()
  hideButton!: boolean;

  /**
   * ID of invoice group to preselect
   */
  @Prop()
  groupId?: string;

  @Prop({ default: () => [] })
  refs!: IReference[];

  @Prop()
  buyerRef?: IReference;

  @Prop()
  vehicleId?: string;

  @Prop()
  fleetId?: string;

  @Prop()
  reportId?: string;

  isDialogActive = false;

  isLoading = false;

  isFormValid = false;

  invoice: IInvoice = new Invoice({ direction: DocumentDirectionEnum.OUTBOUND });
  customerContract?: IContract | null = null;

  get dialogStep() {
    return {
      title: $t("invoice.createInvoice"),
      subtitle: "",
      leftText: $t("close"),
      rightText: $t("create"),
      leftClick: this.close,
      rightClick: this.create,
      rightDisabled: !this.isFormValid
    };
  }

  get partner() {
    return PartnerModule.partner;
  }

  get suggested(): IRefSuggestion[] {
    return [];
  }

  get groups() {
    return GroupModule.filteredAndSorted;
  }

  get fleet() {
    if (!this.invoice.fleetId) {
      return undefined;
    }

    return FleetModule.maps.id.get(this.invoice.fleetId)[0];
  }

  get vehicle() {
    if (!this.invoice.vehicleId) {
      return undefined;
    }

    return VehicleModule.maps.id.get(this.invoice.vehicleId)[0];
  }

  get report() {
    if (!this.invoice.reportId) {
      return undefined;
    }

    return ReportPaginationModule.maps.id.get(this.invoice.reportId)[0];
  }

  get coverageType() {
    return this.report?.coverageType;
  }

  get tableRow(): TableRowType[] {
    const rows = [
      {
        key: this.$t("objects.report.claimNumber"),
        value: this.report?.claimNumber,
        note: this.report?.claimNumber
      },
      {
        key: this.$t("report.accidentDetails.date"),
        value: this.report?.accidentDate,
        note: this.report?.accidentDate ? simpleDate(this.report?.accidentDate.toString()) : ""
      },
      {
        key: this.$t("objects.report.coverageType"),
        value: this.report?.coverageType,
        note: $t(`enums.CoverageTypeEnum.${this.report?.coverageType}`)
      },
      {
        key: this.$t("report.user.MyDamageDetail.customerName"),
        value: this.report?.customerName,
        note: `${this.report?.customerName}`
      },
      {
        key: this.$t("objects.report.insurances.number"),
        value: this.report?.insurances,
        note: this.report?.insurances && this.report?.insurances.length > 0 ? this.report?.insurances[0].number : "",
        isOptional: true
      },
      {
        key: this.$t("common.nouns.licenseplate"),
        value: this.vehicle?.numberplate,
        note: this.vehicle?.numberplate
      },
      {
        key: this.$t("views.fleet.FleetVehicleListView.identificationnumber"),
        value: this.vehicle?.identificationnumber,
        note: this.vehicle?.identificationnumber
      },
      {
        key: this.$t("objects.vehicle.costCenter"),
        value: this.vehicle?.costCenter,
        note: this.vehicle?.costCenter
      }
    ];

    return rows;
  }

  async open() {
    this.invoice = new Invoice({
      status: InvoiceStatusEnum.DRAFT,
      direction: DocumentDirectionEnum.OUTBOUND,
      groupId: this.groupId,
      partnerId: this.partnerId,
      seller: CompanyModule.partner?.invoiceParty,
      refs: this.refs,
      currency: CurrencyEnum.EUR,
      vehicleId: this.vehicleId,
      reportId: this.reportId,
      fleetId: this.fleetId,
      lineItems: [new InvoiceLine()],
      notes: []
    });

    this.tableRow
      .filter(row => row.isOptional !== true)
      .forEach(row => {
        if (row.value) {
          this.invoice.notes?.push(`${row.key} : ${row.note}`);
        }
      });

    this.isDialogActive = true;
  }

  close() {
    this.isDialogActive = false;
  }

  addNote(note: string) {
    this.invoiceForm.addNoteEntry(note);
  }

  validate() {
    this.$log.debug("validate");
    (this.$refs.form as HTMLFormElement).validate();
  }

  async create() {
    try {
      this.isLoading = true;
      this.isDialogActive = true;

      this.invoice.footer = this.invoiceForm.footerDefault;

      await this.invoice?.create();

      this.$emit("created", this.invoice);
      this.$toast.success("👍");
      this.close();
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoading = false;
    }
  }
}
